//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import search from '@/components/search/index.vue'
export default {
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        name: '',
        loading: false
      },
      form: {
        title: ''
      },
      end: false,
      isImg: true, // saas 使用展示图片的风格
      tralvelList: []
    }
  },
  components: {
    uniLoadMore, search
  },
  onLoad() {
    this.queryData()



  },
  onPullDownRefresh() {
    this.tralvelList = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.tralvelList.length < this.page.count) {
      this.queryData()
    }
  },
  methods: {
    nameInput(event) {
      this.form.title = event.target.value || ''
    },
    querySearchData() {
      this.page.currentPage = 1
      this.tralvelList = []
      this.queryData()
    },
    queryData(status) {
      this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/cms/advisory/queryModuleByStoreTenantId',
        data: {
          storeTenantId: this.$store.state.tenantId
        }
      }).then(res => {
        if (res.errCode == 8200) {
          this.$ajax({
            method: 'post',
            url: '/weChat/cms/advisory/queryAdvisoryDetailsPage',
            data: {
              ...this.page,
              ...this.form,
              advisoryCode: res.advisoryCode || '12121'
            }
          }).then(data => {
            // if (data.data.length > 0) {
            //   if (data.data[0].coverPlanUrl) {
            //     this.isImg = true
            //   }
            // }
            this.page.loading = false
            this.page.count = data.count
            this.tralvelList.push.apply(this.tralvelList, data.data)
            if (this.tralvelList.length >= this.page.count) {
              this.end = true
            }
            this.page.currentPage += 1
            if (status === 'refresh') {
              uni.stopPullDownRefresh();
            }
            this.page.loading = false
          })
        } else {
          uni.showToast({
            title: res.message,
            icon: 'none'
          })
          this.page.loading = false
        }
      })
    },
    jump(id) {
      uni.navigateTo({
        url: '/pages/tralvelInfo/detail?id=' + id
      })
    },
    dateFormat(date) {
      return moment(date).format('YYYY/MM/DD')
    }
  }
}
